"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAddSurvicateUserInfo = void 0;
var useAddSurvicateUserInfo_1 = require("./useAddSurvicateUserInfo");
Object.defineProperty(exports, "useAddSurvicateUserInfo", { enumerable: true, get: function () { return __importDefault(useAddSurvicateUserInfo_1).default; } });
